// ---------------------------------------------------------------------------
// Site-Wide Settings
// ---------------------------------------------------------------------------
// Nav links, page titles, footer, and page status.

const site = {
  // Browser tab title
  pageTitle: 'Jack Thoene | ECE PhD Student',

  // Navigation items (rendered in order) — clean root URLs, no ./page.html
  nav: [
    { label: 'Home', href: '/', id: 'nav-intro' },
    { label: 'Publications', href: '/#publications', id: 'nav-publications' },
    { label: 'Projects', href: '/projects', id: 'nav-research' },
    { label: 'News', href: '/news', id: 'nav-news' },
    { label: 'Contact', href: '/#contact', id: 'nav-contact' },
  ],

  // Page status — set to 'Online' or 'UnderConstruction'
  pages: {
    home: { url: '/', status: 'Online' },
    projects: { url: '/projects', status: 'Online' },
  },
};

export default site;
